'use client'

export const Disclaimer = ({ content }: { content: string }) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: content,
      }}
      className="prose text-body-sm font-normal text-bodi-gray-medium"
    />
  )
}
